/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-self-assign */
/* eslint-disable radix */
/* eslint-disable react/button-has-type */
/* eslint-disable no-plusplus */
/* eslint-disable no-else-return */
/* eslint-disable no-lonely-if */
/* eslint-disable no-loop-func */
/* eslint-disable import/no-cycle */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable eqeqeq */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-use-before-define */
/* eslint-disable indent */
/* eslint-disable prefer-destructuring */

// Javascript program to check if there is exist a path between two vertices
// of a graph.
function findAllPath(connectionData, stream_num_dict, roCount) {
	// JavaScript program to print all paths from a source to destination.
	let v;
	let adjList;

	// A directed graph using adjacency list representation
	function Graph(vertices) {
		// initialise vertex count
		v = vertices;
		// initialise adjacency list
		initAdjList();
	}
	// utility method to initialise
	// adjacency list
	function initAdjList() {
		adjList = new Array(v);
		for (let i = 0; i < v; i++) {
			adjList[i] = [];
		}
	}
	// add edge from u to v
	function addEdge(u, v) {
		// Add v to u's list.
		if (!adjList[u]) {
			adjList[u] = [];
		}
		adjList[u].push(v);
	}
	// Prints all paths from
	// 's' to 'd'
	function printAllPaths(s, d) {
		const isVisited = new Array(v);
		for (let i = 0; i < v; i++)
			isVisited[i] = false;
		const pathList = [];
		// add source to path[]
		pathList.push(s);
		// Call recursive utility
		printAllPathsUtil(s, d, isVisited, pathList);
	}
	// A recursive function to print
	// all paths from 'u' to 'd'.
	// isVisited[] keeps track of
	// vertices in current path.
	// localPathList<> stores actual
	// vertices in the current path
	function printAllPathsUtil(u, d, isVisited, localPathList) {
		if (u == (d)) {
			localStorage.setItem('localpath', localPathList);
			// if match found then no need to traverse more till depth
			return;
		}
		// Mark the current node
		isVisited[u] = true;
		// Recur for all the vertices
		// adjacent to current vertex
		for (let i = 0; i < adjList[u].length; i++) {
			if (!isVisited[adjList[u][i]]) {
				// store current node in path[]
				localPathList.push(adjList[u][i]);
				printAllPathsUtil(adjList[u][i], d,
					isVisited, localPathList);
				// remove current node in path[]
				localPathList.splice(localPathList.indexOf
					(adjList[u][i]), 1);

			}
		}
		// Mark the current node
		isVisited[u] = false;
	}

	// Driver program
	// Create a sample graph
	// const edge_dict = {
	// 	'Feed_1': 0,
	// 	'Chem_Dose_1': 1,
	// 	'CF_1': 2,
	// 	'MixSplit_1': 3,
	// 	'HP_Pump_1': 4,
	// 	'RO-HP_1': 5,
	// 	'Stripper_1': 6,
	// 	'HP_Pump_2': 7,
	// 	'RO-HP_2': 8,
	// 	'Product_1': 9,
	// 	'Waste_1': 10
	// };
	const edge_dict = {};
	const unitopList = Object.keys(connectionData.unit_op_dict_final.unit_op_dict);
	unitopList.forEach((item, index) => {
		edge_dict[item] = index;
	});
	Graph(Object.values(connectionData.stream_input_dict_final.stream_input_dict).length + 1);
	Object.values(connectionData.stream_input_dict_final.stream_input_dict).forEach((item) => {
		addEdge(edge_dict[Object.values(item)[0]], edge_dict[Object.values(item)[1]]);

	});

	// Graph(10);
	// addEdge(0, 1);
	// addEdge(1, 2);
	// addEdge(2, 3);
	// addEdge(3, 4);
	// addEdge(4, 5);
	// addEdge(5, 6);
	// addEdge(6, 7);
	// addEdge(7, 8);
	// addEdge(8, 9);
	// addEdge(5, 10);
	// addEdge(8, 3);
	// arbitrary source
	const s = edge_dict[roCount[0]];
	// arbitrary destination
	const d = edge_dict[roCount[roCount.length - 1]];
	printAllPaths(s, d);
	let path = localStorage.getItem('localpath');

	if (path == null) {
		if (roCount.length > 0);
		return;
	}
	path = path.split(',');
	const path1 = Object.keys(edge_dict).find(key => edge_dict[key] === parseInt(path[0]));
	const path2 = Object.keys(edge_dict).find(key => edge_dict[key] === parseInt(path[1]));
	localStorage.removeItem('localpath');

	const flow_sheet_dict = {};

	if (roCount.length >= 2) {
		Object.values(stream_num_dict).filter(
			(item, index) => {
				if (item.source == path1 && item.destination == path2) {
					const streamNum = Number(Object.keys(stream_num_dict)[index]);
					if (connectionData.unit_op_dict_final.unit_op_dict[path1].Product.includes(streamNum)) {
						flow_sheet_dict.Type = `${roCount.length} Pass`;
					}
					else if (connectionData.unit_op_dict_final.unit_op_dict[path1].Waste.includes(streamNum)) {
						flow_sheet_dict.Type = 'Brine Staged';
					}
				}
			}
		);
	}
	else {
		flow_sheet_dict.Type = '1 Pass';
	}
	// added by chandrashekhar 13-sep-2023 return flow_sheet_dict
	return flow_sheet_dict;
	// let V;
	// let adj;

	// function Graph(v) {
	// 	V = v;
	// 	adj = new Array(v);
	// 	for (let i = 0; i < v; ++i)
	// 		adj[i] = [];
	// }
	// // Function to add an edge into the graph
	// function addEdge(v, w) {
	// 	adj[v].push(w);
	// }
	// // prints BFS traversal from a given source s
	// function isReachable(s, d) {
	// 	let temp;
	// 	// Mark all the vertices as not visited(By default set
	// 	// as false)
	// 	const visited = new Array(V);
	// 	for (let i = 0; i < V; i++)
	// 		visited[i] = false;
	// 	// Create a queue for BFS
	// 	const queue = [];
	// 	// Mark the current node as visited and enqueue it
	// 	visited[s] = true;
	// 	queue.push(s);
	// 	while (queue.length != 0) {
	// 		// Dequeue a vertex from queue and print it
	// 		const n = queue.shift();

	// 		if (n == d)
	// 			return true;
	// 		for (let i = 0; i < adj[n].length; i++) {
	// 			if (visited[adj[n][i]] == false) {
	// 				queue.push(adj[n][i]);
	// 				visited[adj[n][i]] = true;
	// 			}
	// 		}

	// 	}

	// 	// If BFS is complete without visited d
	// 	return false;
	// }

	// Graph(10);
	// const edge_dict = {
	// 	'Feed_1': 0,
	// 	'Chem_Dose_1': 1,
	// 	'CF_1': 2,
	// 	'MixSplit_1': 3,
	// 	'HP_Pump_1': 4,
	// 	'RO-HP_1': 5,
	// 	'Stripper_1': 6,
	// 	'HP_Pump_2': 7,
	// 	'RO-HP_2': 8,
	// 	'Product_1': 9,
	// 	'Waste_1': 10
	// };
	// addEdge(0, 1);
	// addEdge(1, 2);
	// addEdge(2, 3);
	// addEdge(3, 4);
	// addEdge(4, 5);
	// addEdge(5, 6);
	// addEdge(6, 7);
	// addEdge(7, 8);
	// addEdge(8, 9);
	// addEdge(5, 10);
	// addEdge(8, 3);
	// // addEdge('Feed_1', 'Chem_Dose_1');
	// // addEdge('Chem_Dose_1', 'CF_1');
	// // addEdge('CF_1', 'MixSplit_1');
	// // addEdge('MixSplit_1', 'HP_Pump_1');
	// // addEdge('HP_Pump_1', 'RO-HP_1');
	// // addEdge('RO-HP_1', 'Stripper_1');
	// // addEdge('Stripper_1', 'HP_Pump_2');
	// // addEdge('HP_Pump_2', 'RO-HP_2');
	// // addEdge('RO-HP_2', 'Product_1');
	// // addEdge('RO-HP_1', 'Waste_1');
	// // addEdge('RO-HP_2', 'MixSplit_1');

	// let u = 5;
	// let v = 8;

	// // let u = 1;
	// // let v = 3;
	// if (isReachable(u, v))
	// 	console.warn(`There is a path from ${u} to ${v} <br>}`);
	// else
	// 	console.warn(`There is no path from ${u} to ${v} <br>}`);

	// u = 3;
	// v = 1;
	// if (isReachable(u, v))
	// 	console.warn(`There is a path from ${u} to ${v} <br>}`);
	// else
	// 	console.warn(`There is no path from ${u} to ${v} <br>}`);
}

export default findAllPath;